/**
 * Wires Swiper navigation to shared hover arrow controls.
 *
 * @param {HTMLElement | null | undefined} root
 * @param {Record<string, unknown>} options
 * @param {number} [slideCount]
 * @returns {Record<string, unknown>}
 */
function attachSwiperNavigation(root, options, slideCount) {
  if (!root || (typeof slideCount === 'number' && slideCount <= 1)) {
    return options;
  }

  const prev = root.querySelector('[data-swiper-nav-prev]');
  const next = root.querySelector('[data-swiper-nav-next]');

  if (prev instanceof HTMLButtonElement && next instanceof HTMLButtonElement) {
    options.navigation = {
      prevEl: prev,
      nextEl: next,
      disabledClass: 'slideshow-control--disabled',
    };
  }

  return options;
}

window.attachSwiperNavigation = attachSwiperNavigation;
